module.exports = __webpack_public_path__ + "media/gift-card/wallet-icon-9d1302a3.svg";